import styled from 'styled-components';

export const ContainerConstructionInfo = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 0.5rem;
  padding: 1rem 1.5rem 2.2rem 1.5rem;

  & > div {
    display: flex;
    column-gap: 1.5rem;
    & > div {
      max-width: 16.875rem;
    }
  }

  & .construction-address {
    max-width: 47.5rem;
    margin-bottom: 1.875rem;
  }
`;

export const ContainerConstructionAddress = styled.div`
  background-color: ${({ theme }) => theme.colors.white};

  & > div {
    display: flex;
    justify-content: flex-start;
    column-gap: 1.5rem;
  }
`;

export const TowerOrBlockContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 0.5rem;
  padding: 1rem 1.5rem 2.2rem 1.5rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
`;

export const ActionsFooterContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 0.5rem;
  padding: 3rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  column-gap: 1rem;
  & > button {
    width: 23rem;
  }
`;

export const Container = styled.div`
  width: 97%;
  margin: 1rem auto 5rem auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1.5rem auto 5rem auto;
    max-width: ${({ theme }) => theme.breakpoints.laptopL};
  }
`;
